import React from 'react';
import { FeedbackProps } from '../../types';

const FeedbackMessage: React.FC<FeedbackProps> = ({ isCorrect, message }) => {
  return (
    <div className={`
      relative inline-block px-6 py-4 rounded-xl shadow-lg text-center overflow-hidden
      ${isCorrect
        ? 'bg-gradient-to-r from-accent-600 to-accent-700 border border-accent-500 shadow-[0_0_30px_rgba(34,197,94,0.5)]'
        : 'bg-gradient-to-r from-red-600 to-red-700 border border-red-500 shadow-[0_0_30px_rgba(239,68,68,0.5)]'
      }
      animate-pulse-slow
    `}>
      {/* Corner accents */}
      <div className={`absolute top-1 left-1 w-3 h-3 border-l-2 border-t-2 ${isCorrect ? 'border-accent-300' : 'border-red-300'} opacity-80`}></div>
      <div className={`absolute top-1 right-1 w-3 h-3 border-r-2 border-t-2 ${isCorrect ? 'border-accent-300' : 'border-red-300'} opacity-80`}></div>
      <div className={`absolute bottom-1 left-1 w-3 h-3 border-l-2 border-b-2 ${isCorrect ? 'border-accent-300' : 'border-red-300'} opacity-80`}></div>
      <div className={`absolute bottom-1 right-1 w-3 h-3 border-r-2 border-b-2 ${isCorrect ? 'border-accent-300' : 'border-red-300'} opacity-80`}></div>
      
      {/* Scanning line effect */}
      <div className="absolute top-0 left-0 w-full h-0.5 bg-gradient-to-r from-transparent via-white to-transparent animate-scan opacity-60"></div>
      
      {/* Content */}
      <div className="relative z-10 flex items-center justify-center space-x-3">
        {/* Status indicator */}
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center font-display font-bold text-lg ${
          isCorrect
            ? 'bg-accent-500 text-white shadow-[0_0_10px_rgba(34,197,94,0.5)]'
            : 'bg-red-500 text-white shadow-[0_0_10px_rgba(239,68,68,0.5)]'
        }`}>
          {isCorrect ? '✓' : '✗'}
        </div>
        
        {/* Message */}
        <div className="text-white">
          <div className="font-display font-bold text-lg tracking-wider uppercase">
            {isCorrect ? 'CORRECT' : 'INCORRECT'}
          </div>
          <div className="font-mono text-sm opacity-90">
            {isCorrect ? 'AI IDENTIFIED' : 'HUMAN SELECTED'}
          </div>
        </div>
      </div>
      
      {/* Glow effect */}
      <div className={`absolute inset-0 rounded-xl ${
        isCorrect
          ? 'bg-gradient-to-r from-accent-500/20 to-accent-400/20'
          : 'bg-gradient-to-r from-red-500/20 to-red-400/20'
      } animate-pulse`}></div>
    </div>
  );
};

export default FeedbackMessage;